module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.crowds.length) ? _c('div', [_c('strong', [_vm._v("适用人群限制：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("只需添加当前票种可以使用的特殊人群使用限制")]), _vm._v(" "), _vm._l((_vm.crowds), function(crowd) {
    return _c('div', [(_vm.crowds.length !== 1) ? _c('div', [_c('b', [_vm._v(_vm._s(crowd.poiName))])]) : _vm._e(), _vm._v(" "), _vm._l((crowd.ticketDiscountList), function(model, index) {
      return _c('div', {
        staticClass: "crowd-item"
      }, [_c('div', [_c('v-select', {
        staticClass: "middle-select inline-input",
        attrs: {
          "placeholder": "请选择",
          "remote": false
        },
        on: {
          "input": function($event) {
            _vm.getOnSelect(model, crowd.options)
          }
        },
        model: {
          value: (model.optIndex),
          callback: function($$v) {
            model.optIndex = $$v
          },
          expression: "model.optIndex"
        }
      }, _vm._l((crowd.options), function(opt, index) {
        return (opt.discountInfo.policyType !== 1) ? _c('v-option', {
          key: index,
          attrs: {
            "label": opt.crowdString,
            "value": index
          }
        }) : _vm._e()
      })), _vm._v(" "), (model.crowd == 1000 && model.crowdString === '其他') ? _c('span', [_c('v-input', {
        directives: [{
          name: "va",
          rawName: "v-va.tab1",
          value: ('required|forbidden'),
          expression: "'required|forbidden'",
          modifiers: {
            "tab1": true
          }
        }],
        staticClass: "inline-input",
        class: {
          'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.otherCrowd', null, index)
        },
        attrs: {
          "data-key": index,
          "forbiddenList": crowd.forbiddenList
        },
        model: {
          value: (model.otherCrowd),
          callback: function($$v) {
            model.otherCrowd = $$v
          },
          expression: "model.otherCrowd"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n                     限制为\n                     "), _c('v-input', {
        staticClass: "inline-input large-select",
        attrs: {
          "maxlength": 60
        },
        model: {
          value: (model.discountInfo.preventCondition),
          callback: function($$v) {
            model.discountInfo.preventCondition = $$v
          },
          expression: "model.discountInfo.preventCondition"
        }
      })], 1), _vm._v(" "), (_vm.mode !== 'readonly') ? _c('span', [_c('button', {
        staticClass: "btn btn-link btn-xs",
        on: {
          "click": function($event) {
            _vm.addItem(crowd.ticketDiscountList)
          }
        }
      }, [_c('i', {
        staticClass: "icon-button icon-plus"
      })]), _vm._v(" "), (model.crowd !== null || model.discountInfo.preventCondition !== null || crowd.ticketDiscountList.length > 1) ? _c('button', {
        staticClass: "btn btn-link btn-xs",
        on: {
          "click": function($event) {
            _vm.removeItem(model, index, crowd.ticketDiscountList)
          }
        }
      }, [_c('i', {
        staticClass: "icon-button delete icon-cancel"
      })]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (model.freeInfo.policyType === 1) ? _c('div', [_vm._v("\n                " + _vm._s(model.crowdString) + _vm._s(model.freeInfo.preventCondition) + "免费\n                "), (_vm.extra.isBD) ? _c('span', {
        staticClass: "text-warning",
        staticStyle: {
          "margin-left": "5px"
        }
      }, [_vm._v("请仔细核对免票信息，如有误，请前往CRM系统中报错")]) : _c('span', {
        staticClass: "text-warning",
        staticStyle: {
          "margin-left": "5px"
        }
      }, [_vm._v("请仔细核对免票信息，若有误请向您的BD报错")])]) : _vm._e(), _vm._v(" "), (_vm.validateErrors.has('tab1', 'model.otherCrowd', 'required', index)) ? _c('div', {
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("\n                适用人群不能为空\n            ")]) : (_vm.validateErrors.has('tab1', 'model.otherCrowd', 'forbidden', index)) ? _c('div', {
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("\n                该人群已存在，请勿重复填写，若有人群限制不同，可修改人群限制内容\n            ")]) : _vm._e()])
    })], 2)
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cbc508e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/discountDes.vue
// module id = 530
// module chunks = 0